import { useAppSelector } from '@hooks/app/redux';
import useEnvService from '@hooks/app/useEnvService';
import { searchClients } from '@services/external/client.api';
import type { UseQueryOptions } from 'react-query';
import { useQuery } from 'react-query';
import { IClientSearchItem, IClientSearchParams } from 'types/client.types';

async function handler(providerId: string, jabberIds: string[]) {
  if (jabberIds.length === 0) {
    return [] as IClientSearchItem[];
  }

  const params: IClientSearchParams = {
    page: 1,
    pageSize: jabberIds.length,
    myClients: null,
    jabberIds,
    sortBy: 'createdAt',
    direction: 'ASC',
    status: 'paired',
  };

  const { data } = await searchClients(providerId, params);

  return data.data.items;
}

type TQueryData = Awaited<ReturnType<typeof handler>>;

function useXmppContacts(
  extraJids: string[] = [],
  options?: UseQueryOptions<TQueryData, unknown, TQueryData, any[]>,
) {
  const providerId = useAppSelector((state) => state.users.currentProvider?.id)!;
  const xmppContacts = useAppSelector((state) => state.directChat.contacts);
  const [env] = useEnvService();

  return useQuery(
    ['xmpp:contacts', providerId, xmppContacts, extraJids, env.xmpp.hilbiJid],
    () =>
      handler(
        providerId,
        Array.from(new Set([...extraJids, ...xmppContacts.map((c) => c.jid), env.xmpp.hilbiJid])),
      ),
    options,
  );
}

export default useXmppContacts;
